// A ~30-line observable store, in place of a framework.
//
// The whole renderer is one state object and one render function. That is not
// a limitation to work around — it is the reason the bundle is 20 KB instead
// of 60 — so resist the urge to grow this into a reactive system. If a screen
// needs something, put it in the state.

export type Unsubscribe = () => void;

export class Store<T> {
  private listeners = new Set<(state: T) => void>();

  constructor(private state: T) {}

  get(): T {
    return this.state;
  }

  /**
   * Applies a partial update and notifies subscribers.
   *
   * Notification is SYNCHRONOUS and unconditional — no equality check. The
   * render is cheap, and a "did anything change?" comparison on a state
   * object containing maps is both slower and a source of missed updates.
   */
  set(patch: Partial<T>): void {
    this.state = { ...this.state, ...patch };
    for (const listener of this.listeners) listener(this.state);
  }

  subscribe(listener: (state: T) => void): Unsubscribe {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }
}
